import React from 'react';
import Other from './Other';
import Previewable from './Previewable';

import {useCommunitySubEvent} from '../../../../data/hooks/communityHooks';
import {useMarkNotificationsRead} from '../../../../data/hooks/notifications/useMarkNotificationsRead';

const SubEvent = props => {
    const {communityId, eventId, notifications} = props,
        event = useCommunitySubEvent(communityId, eventId);

    useMarkNotificationsRead(notifications);

    if (event.preview_allowed) {
        return <Previewable communityId={communityId} eventId={eventId} />;
    } else {
        return <Other communityId={communityId} eventId={eventId} />;
    }
};

export default SubEvent;
